import script from "./TabReportGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabReportGlobal.vue?vue&type=script&setup=true&lang=ts"

import "./TabReportGlobal.vue?vue&type=style&index=0&id=489e5692&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489e5692"]])

export default __exports__